import { LicenseKeys } from '@bimser/core';
import DevDataGrid, { DataGridRef } from 'devextreme-react/data-grid';
import config from 'devextreme/core/config';
import React, { useMemo } from 'react';
import { loadPanel } from '../constants';
import { BCDataGridProps, BCDataGridRef } from '../entities';
import { useEventEmitter, useLocalization } from './hooks';

config({ licenseKey: LicenseKeys.DEVEXTREME_LICENSE_KEY });

import '../../common/assets/devextreme/generic/dx.generic.module.css';
import '../../common/assets/devextreme/generic/reset.module.css';

export const DataGrid = React.forwardRef<BCDataGridRef, BCDataGridProps>((props, ref) => {
	const dxDataGridRef = React.useRef<DataGridRef>();

	useEventEmitter(props.name, dxDataGridRef);
	useLocalization();

	React.useImperativeHandle(ref, () => dxDataGridRef.current);

	const elementAttr = useMemo(
		() => ({
			'data-selenium-id': props.name
		}),
		[props.name]
	);

	return (
		<DevDataGrid
			ref={dxDataGridRef}
			id={props.name}
			key={props.name}
			elementAttr={elementAttr}
			loadPanel={loadPanel}
			{...props}
		/>
	);
});
